export default __webpack_public_path__ + "media/project-management.f9973bed3f07145f29fd74f2856aede3.svg";